import { render, staticRenderFns } from "./HowToUploadRecipientsComponent.vue?vue&type=template&id=576f9c0f&scoped=true&"
import script from "./HowToUploadRecipientsComponent.vue?vue&type=script&lang=js&"
export * from "./HowToUploadRecipientsComponent.vue?vue&type=script&lang=js&"
import style0 from "./HowToUploadRecipientsComponent.vue?vue&type=style&index=0&id=576f9c0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576f9c0f",
  null
  
)

export default component.exports